export const NAME = 'emailvalidation';

// User email validation start procedure constants
export const REQUEST_EMAIL_VALIDATION_COMMIT = 'REQUEST_EMAIL_VALIDATION_COMMIT';
export const SUCCESS_EMAIL_VALIDATION_COMMIT = 'SUCCESS_EMAIL_VALIDATION_COMMIT';
export const FAILURE_EMAIL_VALIDATION_COMMIT = 'FAILURE_EMAIL_VALIDATION_COMMIT';



// WEBPACK FOOTER //
// ./src/services/authentication/emailvalidation/constants.js